var map = {
	"./s1.jpg": 9501,
	"./s10.jpg": 2017,
	"./s11.jpg": 2068,
	"./s12.jpg": 4643,
	"./s2.jpg": 242,
	"./s3.jpg": 2911,
	"./s4.jpg": 2100,
	"./s5.jpg": 9473,
	"./s6.jpg": 8054,
	"./s7.jpg": 227,
	"./s8.jpg": 6728,
	"./s9.jpg": 7909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 339;